import React from "react";
import ReactGA from "react-ga4";
import {Link} from 'react-router-dom';
// import FooterLinks from './footer-links/footer-links.js';
import HelpAndCurrency from './help-and-currency.js';
import AboutLinks from './footer-links/about-links.js';
import * as Utilities from './utilities.js';

export default class Tariff_faq extends React.Component {
  componentDidMount() {
	  var ga = Utilities.gaInitialize(ReactGA);
	  Utilities.gaPageView(ga, "msa_page_view", "/tariff_faq", "Tariff FAQ");
  }
  render(){

    return(
      <div>

        <div className='content-area-container'>
          <div className="replacement_parts_header">
            <h1>Tariff FAQ</h1>
          </div>

          <div className="tariff-faq">


                <h3>Key Takeaways</h3>
                <ul>
                    <li>With continued uncertainty surrounding tariffs, all costs have been directly impacted.</li>
                    <li>This change has been implemented effective May 5th, 2025.</li>
                </ul>
         </div>
                <div className="tariff-faq">
                <b>What is a tariff?</b>
                <br/>A tariff is a tax imposed by a government on goods or services imported from another country, usually calculated as a percentage of the value of the goods.
                </div>
                
                <div className="tariff-faq">
                <b>Why are tariffs imposed?</b>
                <br/>Tariffs are typically imposed to protect domestic industries from foreign competition, to raise revenue for a government, or to address trade imbalances.
                </div>
                
                <div className="tariff-faq">
                <b>How do tariffs affect the cost of MS Air products?</b>
                <br/>Tariff amounts will vary by product manufacturer. You will see the tariff cost upon check out as a separate line item.
                </div>
                


          <div className="FooterLinks1">
            <HelpAndCurrency />

          </div>
          <div className="FooterLinks2">
            <AboutLinks />
          </div>
              </div>
              <div className="about-footer">
                <div className="terms">
                  <p><a href="/terms" rel="noopener noreferrer">Terms of Use</a> | <a href="/privacy" rel="noopener noreferrer">Privacy Policy</a></p>
                </div>
                <div className="copyright">
                  <p>&copy; 2018 - MS Air, Inc. | <Link to="/">Home</Link></p>
              </div>
            </div>



    </div>
    )
  }
}
